<template>
    <div class="devices-list__block" v-if="controllerData" @click="openController">
        <v-layout row class="devices-list__block__title">
            <div class="common-text">
                <div class="status-marker ml-2">
                    <div :class="controllerData.online ? 'green-color' : 'red-color'"></div>
                </div>
                {{controllerData.online ? "online" : "offline"}}
            </div>
            <div
                v-if="!edit"
                v-html="require('!html-loader!@/assets/icons/reboot_icon.svg')"
                class="d-inline-flex size-24 ml-2"
                @click.stop.prevent="rebootController()"
            />
            <div v-if="edit">
                <div
                    v-html="require('!html-loader!@/assets/icons/edit_icon.svg')"
                    class="d-inline-flex size-24 ml-2"
                    @click.stop.prevent="openEditController()"
                />
                <div
                    v-html="require('!html-loader!@/assets/icons/close_icon.svg')"
                    class="d-inline-flex size-24 ml-2"
                    @click.stop.prevent="openDeleteController()"
                />
            </div>
        </v-layout>
        <v-layout row class="devices-list__block__title">
            <div class="main-text main-text__bold">{{controllerData.name}}</div>
        </v-layout>
        <ModalMessage
            v-model="openDeleteControllerModal"
            title="Открепление контроллера"
            :text="deleteText"
            text-btn="Отменить"
            text-confirm-btn="Удалить"
            show-confirm-btn
            text-center
            @confirm="deleteController"
        />
    </div>
</template>

<script>
import ModalMessage from "@/components/modals/ModalMessage";
export default {
    name: "ControllerCard",
    components: {ModalMessage},
    props: {
        controller: {
            type: [Array, Object],
            default: null,
        },
    },
    data() {
        return {
            controllerData: {},
            openEditControllerModal: false,
            openDeleteControllerModal: false,
            deleteText: null,
        };
    },
    created() {
        this.controllerData = this.controller;
    },
    computed: {
        edit() {
            return this.$store.getters.editMode;
        },
        home() {
            return this.$store.getters.home;
        },
    },
    watch: {
        device(val) {
            if (val) {
                this.controllerData = val;
            }
        },
    },
    methods: {
        rebootController() {
            this.$http.put(`/controllers/home/reboot-controller/${this.controllerData.uid}/`, {
                force: true,
            })
                .then((response) => {
                    console.log(response);
                })
                .catch((error) => {
                    console.log(error);
                    this.cancel();
                });
        },
        openEditController() {
            this.openEditControllerModal = true;
        },
        openDeleteController() {
            this.deleteText = `Вы действительно хотите открепить контроллер ${this.controllerData.name}?`;
            this.openDeleteControllerModal = true;
        },
        deleteController() {
            this.$http.delete(`/controllers/home/management-controller/${this.controllerData.uid}/?controller=${this.home}/`)
                .then(() => {
                    this.openDeleteControllerModal = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.cancel();
                });
        },
        openController() {
            if (this.controllerData) {
                if (this.controllerData.model == 1) {
                    this.$router.push({ name: "debugcontrollerpage", params: { id: this.controllerData.uid } });
                } else if (this.controllerData.model == 2) {
                    this.$router.push({ name: "controllerpage", params: { id: this.controllerData.uid } });
                }
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.status-marker {
    align-items: center;
    display: inline-flex;

    .green-color,
    .red-color {
        height: 12px;
        width: 12px;
        border-radius: 6px;
    }

    .green-color {
        background: #42D829;
    }

    .red-color {
        background: var(--rh-error-color);
    }
}
</style>